<template>
  <div class="ba-flex ba-h-full">
    <div class="ba-flex-shrink-0 ba-w-160 ba-mr-4 ba-bg-white ba-border ba-overflow-auto">
      <div class="ba-p-6">
        <vis-approval-queue-header />
        <!-- Этапы -->
        <vis-approval-queue-stage
          v-for="(stage, index) in stages"
          :key="index"
          :stage="stage"
          :is-last="isLastElem(index, stages)"
          class="ba-mb-10 last:ba-mb-0"
        />
        <!-- ============== -->
      </div>
    </div>
    <div class="ba-flex-shrink-0 ba-w-120 ba-mr-4 ba-bg-white ba-border ba-overflow-auto">
      <div class="ba-p-6">
        <vis-approval-queue-stage
          v-for="(stage, index) in stages2"
          :key="index"
          :stage="stage"
          :is-last="isLastElem(index, stages2)"
          class="ba-mb-10 last:ba-mb-0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import exampleStages from "./example-stages";
import exampleStages2 from "./example-stages-2";

import visApprovalQueueHeader from "./vis-approval-queue-header";
import visApprovalQueueStage from "./vis-approval-queue-stage";

export default {
  name: "vis-approval-queue",
  components: {
    visApprovalQueueHeader,
    visApprovalQueueStage,
  },
  data() {
    return {
      stages: exampleStages,
      stages2: exampleStages2
    }
  },
  methods: {
    isLastElem(i, el) {
      return i === el.length - 1;
    },
  }
};
</script>
